import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { getLLMUsageTier, listLLMUsageTiers } from "../graphql/queries";
import {
  GetLLMUsageTierQuery,
  ListLLMUsageTiersQuery,
  ModelLLMUsageTierFilterInput,
  LLMUsageTier,
} from "../API";

// Fetch lineage by baseUsageTierId (for v2+), and include the root v1 (id === baseId)
// Falls back to client-side sort by version ASC
export async function fetchLLMUsageTiersByBase(
  baseId: string
): Promise<LLMUsageTier[]> {
  const lineage: LLMUsageTier[] = [];

  // 1) Fetch root v1 by id (it has baseUsageTierId === null)
  const baseRes = (await API.graphql(
    graphqlOperation(getLLMUsageTier, { id: baseId })
  )) as GraphQLResult<GetLLMUsageTierQuery>;
  if (baseRes.data?.getLLMUsageTier) {
    lineage.push(baseRes.data.getLLMUsageTier as unknown as LLMUsageTier);
  }

  // 2) Fetch all descendants where baseUsageTierId == baseId (paginate)
  let nextToken: string | null | undefined = undefined;
  const filter: ModelLLMUsageTierFilterInput = { baseUsageTierId: { eq: baseId } };
  do {
    const res = (await API.graphql(
      graphqlOperation(listLLMUsageTiers, {
        filter,
        limit: 100,
        nextToken,
      })
    )) as GraphQLResult<ListLLMUsageTiersQuery>;

    if (res.data?.listLLMUsageTiers?.items) {
      for (const item of res.data.listLLMUsageTiers.items) {
        if (item) lineage.push(item as unknown as LLMUsageTier);
      }
      nextToken = res.data.listLLMUsageTiers.nextToken;
    } else {
      nextToken = undefined;
    }
  } while (nextToken);

  // Sort by version ascending (v1 first)
  lineage.sort((a, b) => (a.version ?? 0) - (b.version ?? 0));
  return lineage;
}
